module.exports = __webpack_public_path__ + "static/media/mycart_product_3.c1989839.png";